module.exports = __webpack_public_path__ + "static/media/clock-active.affbedd8.svg";